import classNames from "classnames";
import React from "react";

const BASE_CLASSES = [
  "font-sans-serif",
  "rounded-sm",
  "cursor-pointer",
  "text-center",
  "flex",
  "items-center",
  "justify-center",
  "gap-2",
  "p-5",
  "text-sm",
  "transition-all",
  "font-semibold",
];

const INTENT_CLASSES = {
  primary: [
    "bg-purple",
    "text-white",
    "border",
    "border-transparent",
    "hover:!text-black",
    "hover:bg-transparent",
    "hover:!border-light-neutral-2",
  ],
  secondary: [
    "text-black",
    "bg-transporent",
    "border",
    "border-light-neutral-2",
    "hover:bg-purple",
    "hover:!text-white",
  ],
};

export type CaButtonTagProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    children?: React.ReactNode;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    disabled?: boolean;
    intent?: "primary" | "secondary";
    type?: "button" | "submit" | "reset";
    fill?: boolean;
  };

function CaButtonTag({
  children,
  className,
  onClick,
  disabled,
  intent,
  href,
  type = "button",
  fill,
  ...props
}: CaButtonTagProps) {
  const classes = classNames(BASE_CLASSES, INTENT_CLASSES[intent || "primary"], className);

  const Component = href ? "a" : "button";

  return (
    <Component
      type={type}
      className={classes}
      onClick={onClick}
      href={href}
      style={{ borderRadius: "40px" }}
      {...props}
    >
      {children}
    </Component>
  );
}

CaButtonTag.defaultProps = {
  intent: "primary",

  outlined: false,
};

export default CaButtonTag;
